(function ($) {
	// set the bg position
	$(".hero").each(function () {
		if ($(this).data("lg-background-position")) {
			let thisStyle = $(this).attr("style");
			if (getIsSmall()) {
				$(this).attr(
					"style",
					thisStyle +
						"background-position: " +
						$(this).data("sm-background-position")
				);
			} else {
				$(this).attr(
					"style",
					thisStyle +
						"background-position: " +
						$(this).data("lg-background-position")
				);
			}
		}
	});

	// Video controls
	$(".hero-video-play").on("click", function () {
		if ($(this).hasClass("pause")) {
			$(this).removeClass("pause").addClass("play");
      $(this).attr("aria-label", "Play video").attr("aria-pressed", "true");
			$(".video video").get(0).pause();
		} else {
			$(this).removeClass("play").addClass("pause");
      $(this).attr("aria-label", "Pause video").attr("aria-pressed", "false");
			$(".video video").get(0).play();
		}
	});

	// Logo Url Variable
	var $title = $(".title");
	var logoUrl = $title.data("logo-url");

	if (logoUrl) {
		$title.css("--logo-url", `url(${logoUrl})`);
	}
})(jQuery);
